<template>
  <div
    class="table-search-container"
  >
    <a-input-search
      placeholder="请输入搜索内容"
      style="width:225px;"
      @search="value => $emit('onSearch', value)"
    />

    <a-tree-select
      v-model="value"
      style="width: 200px;margin:0 10px;"
      :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
      :tree-data="treeData"
      placeholder="全部科室"
      default-value="0"
      @change="value => $emit('onChange', value)"
    />
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      {{ addText }}
    </a-button>
  </div>
</template>
<script>
export default {
  props: [ 'addText'],
  data() {
    return {
      treeData: [{
        title: '全部科室',
        value: '0',
        key: '0',
      }],
      value: undefined};
  },
  mounted(){
    this.getTableData();
  },
  methods: {
    filterOption(input, option) {
      // return (
      //   option.componentOptions.children[0].text
      //     .toLowerCase()
      //     .indexOf(input.toLowerCase()) >= 0
      // );
    },
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title=item.name;
        item.key=item.id;
        item.value=String(item.id);
        item.children=item.child_list;
        if (item.child_list && item.child_list.length > 0) {
          this.dealData(item.child_list);
        }
      });
      return data;
    },
    // 获取科室
    async getTableData() {
      this.loading = true;
      let result = await this.$http.post('/department/adminGetList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.treeData = [...this.treeData, ...this.dealData(JSON.parse(JSON.stringify(data)))];
        console.log('getTableData ->  this.treeData',  this.treeData);
      }
    },
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-select-selection {
    border-radius: 15px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
